import { render, staticRenderFns } from "./USIndividual.vue?vue&type=template&id=57271220&scoped=true&"
import script from "./USIndividual.vue?vue&type=script&lang=js&"
export * from "./USIndividual.vue?vue&type=script&lang=js&"
import style0 from "./USIndividual.vue?vue&type=style&index=0&id=57271220&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57271220",
  null
  
)

export default component.exports